import { useTenant } from '../../context/TenantContext'

/**
 * True when the current org is the Italian tenant. The single gate for every
 * Italy-only surface — shared step files import this and render an Italy
 * component behind it, so Italy logic never leaks into the DE/ES paths.
 */
export function useIsItaly(): boolean {
  const { tenant } = useTenant()
  return tenant?.country === 'IT'
}
